import React from 'react';
import { Dialog, DialogContent, DialogTitle, Text, XStack, YStack } from 'tamagui';

import { GradientButton } from './GradientButton';

interface CustomDialogProps {
  width?: string;
  height?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onButtonPress: () => void;
  buttonLabel?: string;
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

export const CustomDialog: React.FC<CustomDialogProps> = ({
  width,
  height,
  open,
  onOpenChange,
  onButtonPress,
  buttonLabel = 'Try Again',
  title = 'Incorrect Password',
  description,
  children,
}) => {
  const dialogKey = `dialog-${title?.replace(/\s+/g, '-').toLowerCase() || 'default'}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal key={`${dialogKey}-portal`}>
        <Dialog.Overlay
          key={`${dialogKey}-overlay`}
          position="absolute"
          left={0}
          top={0}
          width="100%"
          height="100%"
          backgroundColor="rgba(0,0,0,0.4)"
          zIndex={99999}
        />
        <DialogContent
          key={`${dialogKey}-content`}
          bordered
          elevate
          height={height + 'px'}
          width={751}
          padding="$6"
          backgroundColor="$background"
          borderRadius={16}
          alignItems="flex-start"
          gap="16px"
          zIndex={100000}
          position="absolute"
          left="584.5px"
          top={240 - Number(height) / 2}>
          <DialogTitle
            fontSize="$8"
            color="$white12"
            padding={0}
            fontWeight="700"
            lineHeight="58px">
            {title}
          </DialogTitle>
          <YStack gap="$6">
            <Text fontSize="36px">{description}</Text>
            <XStack gap="16px">
              <GradientButton label={buttonLabel} isActive onPress={onButtonPress} width={width} />
              {children}
            </XStack>
          </YStack>
        </DialogContent>
      </Dialog.Portal>
    </Dialog>
  );
};
